var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapitol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5 1h2M4 2h1m2 0h1M3 3h1m4 0h1M2 4h1m6 0h1M1 5h1m8 0h1M0 6h1m10 0h1M1 7h1m8 0h1M1 8h1m8 0h1M1 9h1m8 0h1M1 10h1m8 0h1M1 11h4m2 0h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4f00",
    d: "M5 2h1M4 3h2M3 4h3M2 5h4M1 6h5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0019",
    d: "M6 2h1M6 3h2M6 4h3M6 5h4M6 6h5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c9c0aa",
    d: "M2 7h4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#a1a3af",
    d: "M6 7h4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff6e0",
    d: "M2 8h4M2 9h3m-3 1h3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d7d9e5",
    d: "M6 8h4M7 9h3m-3 1h3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    d: "M5 9h2m-2 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitol);
export default __webpack_public_path__ + "static/media/capitol.7d3064cca75a6cc773b4f500c66a30e5.svg";
export { ForwardRef as ReactComponent };